module.exports = __webpack_public_path__ + "static/media/Google Pixel 4 XL Just Black.e87085f0.png";